import React, { useEffect, useState } from "react";
import { Modal, Form, Tooltip, Avatar, Input, Button, Table } from "antd";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../common";
import { useStore } from "../../store";
import "../microsite-accordian/style.scss";
import "./manage-microsites.scss";
import UserIcon from "../../assets/images/icons/userLogo.svg";
import uuid from "react-uuid";
import Preview from "../microSites/edit/preview";
import deleteIcon from "../../assets/images/delete-icon.svg";
import duplicateIcon from "../../assets/images/duplicate-icon.svg";
import { setMicroSiteActions, setMicroSites } from "../../store/actions";
import { useNavigate, useLocation } from "react-router-dom";
import { TAB_KEYS } from "../../config";
import backArrow from "../../assets/images/back-arrow.svg";
import { SecureDeleteFlow } from "../secure-delete";
import siteDeleteService from "../../api/siteDeleteService";
import { ROLE } from "../../utils/constants";
import {
  armRosieForNewSite,
  hasRosieWebsiteLink,
} from "../../utils/rosieNewSite";
import { isValidPhoneWithCountryCode } from "../../utils/phoneValidation";

function ManageMicrosite() {
  const [loading, setLoading] = useState(true);
  const { settings, dispatch, microSiteActions } = useStore();
  // const { getMicroSites } = useMicrosite();
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [logo, setLogo] = useState();
  const [logoFile, setLogoFile] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [totalData, setData] = useState([]);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState();
  const [deleteSiteName, setDeleteSiteName] = useState("");
  const [reloadFlag] = useState(false);
  const [previewId, setPreviewId] = useState();
  const [previewRow] = useState();
  const [isBtnDisabled, setIsBtnDisabled] = useState(false); // used by create/add microsite form
  const navigate = useNavigate();
  const { state } = useLocation();


  useEffect(() => {
    getAllMicrosites();
  }, [reloadFlag]);

  const handleDelete = (row) => {
    setDeleteRowId(row.id);
    setDeleteSiteName(row.name || "");
    setIsModalDeleteOpen(true);
  };

  const handleCancelDelete = () => {
    setIsModalDeleteOpen(false);
    setDeleteRowId(undefined);
    setDeleteSiteName("");
  };

  const getAllMicrosites = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const response = await getRequest(userServiceApi.getAllMicrosites(), {
        headers,
      });

      if (response) {
        const remaining = response.data || [];
        setData(remaining);
        dispatch(setMicroSites(remaining));
        setLoading(false);
        return remaining;
      }
    } catch (error) {
      toast.error(error);
    }
    return [];
  };

  const handleSecureDeleteSuccess = async () => {
    const deletedId = deleteRowId;
    const remaining = (await getAllMicrosites()) || [];
    const storedId = localStorage.getItem("micrositeId");
    const storedWasDeleted = String(storedId) === String(deletedId);
    const storedStillExists = remaining.some(
      (site) => String(site.id) === String(storedId)
    );

    if (storedWasDeleted || (storedId && !storedStillExists)) {
      if (remaining.length > 0) {
        localStorage.setItem("micrositeId", remaining[0].id);
      } else {
        localStorage.removeItem("micrositeId");
      }
    }
  };

  const validatePhoneBeforeDeleteOtp = async () => {
    const response = await getRequest(userServiceApi.getProfile());
    const status = response?.status ?? response?.response?.status;
    const isHttpError =
      response?.isAxiosError ||
      (typeof status === "number" && status >= 400) ||
      Boolean(response?.response);

    if (isHttpError || !response?.data) {
      throw new Error(
        "Unable to verify your phone number. Please try again or update it in Personal Details."
      );
    }

    const phoneNumber = response.data.phoneNumber;
    if (!isValidPhoneWithCountryCode(phoneNumber)) {
      throw new Error(
        "Please update your phone number in Personal Details before deleting a site."
      );
    }
  };

  useEffect(() => {
    getAllMicrosites();
  }, []);

  const handleMenus = (activeKey, menuKey, change) => {
    localStorage.setItem("micrositeId", activeKey);
    dispatch(setMicroSiteActions({ activeKey, menuKey, change }));
  };

  const handleFileChange = (event) => {
    const MAX_SIZE = 2 * 1024 * 1024; // 2MB
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    var fileName = event.target.files[0].name;
    var FT = event.target.files[0].type;

    if (fileName && !allowedTypes.includes(FT)) {
      toast.error("Only image files are allowed(JPG, PNG, JPEG)");
      return;
    } else if (event.target.files && event.target.files[0].size > MAX_SIZE) {
      toast.error("File size should not exceed 2MB");
      return;
    }
    const file = event.target.files[0];
    if (file) {
      let unique_ID = uuid();

      const fileNameArray = file.name.split(".");
      const fileExtension = fileNameArray[fileNameArray.length - 1];
      const fileName = fileNameArray.slice(0, -1).join(".");
      setLogo({
        mediaType: "IMAGE",
        mediaProperty: {
          id: unique_ID,
          name: fileName,
          extension: fileExtension,
        },
      });

      const blob = file.slice(0, file.size);
      const newLogo = new File(
        [blob],
        `${unique_ID}_${fileName}.${fileExtension}`,
        {
          type: file.type,
        }
      );

      setLogoFile(newLogo);
      setSelectedImage(URL.createObjectURL(newLogo));
    }
  };

  const onFinish = async (values) => {
    setIsBtnDisabled(true);
    const formData = new FormData();

    if (logoFile) {
      formData.append("media", logoFile);
    }

    const micrositeProfileInput = {
      name: values.name,
      media: logo,
      website: values?.website ?? "",
    };
    const json = JSON.stringify(micrositeProfileInput);
    const blob = new Blob([json], {
      type: "application/json",
    });
    formData.append("micrositeProfileInput", blob);

    try {
      const response = await postRequest(
        userServiceApi.createMulMicrosite(),
        formData
      );


      if (response) {
        setIsBtnDisabled(false);
        toast.success("Site created successfully!");
        const createdSiteId = String(
          response?.id ?? response?.data?.id ?? "",
        );
        const createdWebsite =
          values?.website ||
          response?.websiteLink ||
          response?.website ||
          "";
        if (createdSiteId && String(createdWebsite).trim()) {
          armRosieForNewSite(createdSiteId);
        }
        sessionStorage.setItem("skipAutoOpenMicrosite", "true");
        navigate("/", { state: state ? state : TAB_KEYS.aboutUs })
        // getMicroSites();
        closeModal();
      } else {
        setIsBtnDisabled(false);
        console.error("Failed to create microsite. Please try again.");
      }
    } catch (error) {
      setIsBtnDisabled(false);
      toast.error(`Error: ${error.message}`);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    form.resetFields();
    setSelectedImage(null);
    setLogo(null);
    setLogoFile(null);
  };

  const addMicrosite = () => {
    setModalVisible(true);
  };

  const callDuplicate = async (micrositeID) => {
    try {
      const existingIds = new Set(
        (totalData || []).map((site) => String(site.id)),
      );
      const sourceSite = (totalData || []).find(
        (site) => String(site.id) === String(micrositeID),
      );
      const res = await postRequest(
        userServiceApi.duplicateMicrosite(micrositeID))
      if (res) {
        toast.success("Successfully duplicated microsite")

        // Prefer id from API; otherwise detect the new row after refresh.
        const responseSiteId = String(
          res?.id ?? res?.data?.id ?? "",
        );
        const duplicatedHasWebsite =
          hasRosieWebsiteLink(res) || hasRosieWebsiteLink(sourceSite);
        if (responseSiteId && duplicatedHasWebsite) {
          armRosieForNewSite(responseSiteId);
        }

        setTimeout(async () => {
          const refreshed = await getAllMicrosites();
          if (!responseSiteId && Array.isArray(refreshed)) {
            const created = refreshed.find(
              (site) => !existingIds.has(String(site.id)),
            );
            if (created?.id && hasRosieWebsiteLink(created)) {
              armRosieForNewSite(String(created.id));
            }
          }
        }, 1000);

      }
    } catch (error) {
      toast.error("Duplicating Site not successful")
    }
  }

  const columns = [
    {
      title: "Site Name",
      dataIndex: "name",
      key: "name",
      render: (t, r) => (
        <div className="microsite-info">
          <div className="table-microsite-logo"><img src={r.mediaLink} alt="micrositeLogo" /></div>
          <div className="table-microsite-name">{r.name}</div>
        </div>
      )
    },
    {
      title: " ",
      dataIndex: " ",
      key: "action",
      render: (value, row, index) => (
        <div className="microsite-header-last">
          <div className="microsite-header-last-sub">
            <div
              className="microsite-header-last-sub-sec"
              onClick={() => handleDuplicate(row.id)}
            >
              <img className="manage-table-icons" src={duplicateIcon} alt="" />
              <div className="microsite-header-last-sub-sec-label">
                Duplicate
              </div>
            </div>
            {/* <div
              className="microsite-header-last-sub-sec"
              onClick={() => {
                setPreviewId(row.id)
                setPreviewRow(row)
                handleMenus(row.id, "preview", true)
              }}
            >
              <img className="manage-table-icons" src={previewIcon} />
              <div className="microsite-header-last-sub-sec-label">
                Preview
              </div>
            </div> */}
            <div
              className="microsite-header-last-sub-sec"
              onClick={() => handleDelete(row)}
            >
              <img className="manage-table-icons" src={deleteIcon} alt="" />
              <div className="microsite-header-last-sub-sec-label">
                Delete
              </div>
            </div>
          </div>
        </div>
      )

    }
  ]



  const handleDuplicate = (micrositeID) => {

    callDuplicate(micrositeID);
  }

  if (loading) return <LoadingView message="Loading..." />;

  return (
    <div className="tabContainer">
      <div className="add-microsite-btn">
        <div className="header page-header" style={{
          flex: '1'
        }}>
          <div className="backbtn-container" style={{
            flex: '1'
          }}>
            <img src={backArrow} style={{ width: "22px" }} alt="" onClick={() => navigate('/')} />
            <p>Manage Sites</p>
          </div>
        </div>
        <Button
          className="greenBtn"
          // htmlType="submit"
          onClick={addMicrosite}
        >
          Add New Site
        </Button>
      </div>
      <Modal
        className="confirmation-modal"
        open={modalVisible}
        footer={null}
        onCancel={closeModal}
        width={600}
      >
        <div className="formInfoStyle">
          <Form
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 10 }}
            form={form}
            onFinish={onFinish}
            autoComplete="off"
          >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="Site name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Site name is required",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        const urlPattern =
                          /^(https?:\/\/|www\.)|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/i;

                        if (urlPattern.test(value.trim())) {
                          return Promise.reject(
                            new Error("Site name should contain text only")
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input style={{ width: 300 }} />
                </Form.Item>

                <Form.Item
                  label={
                    <div className="ant-form-item-label">
                      <label htmlFor="media" title="Organisation logo">
                        Site logo
                      </label>
                    </div>
                  }
                  colon={false}
                  name="media"
                  className="experienceImg centered-label"
                  rules={[
                    { required: true, message: "Logo is required" },
                  ]}
                >
                  <div className="choose-btn" style={{ gap: "12px" }}>
                    {selectedImage ? (
                      <img className="org-admin-logo" src={selectedImage} alt="logo" />
                    ) : (
                      <Avatar size={64} src={UserIcon} />
                    )}
                    <div className="d-flex">
                      <Tooltip title="Upload image with size lesser than 2.5MB. Recommended image dimensions: 1280x720 pixels">
                        <label className="fileUploadBtn greenBtn" style={{ padding: "0 8px" }}>
                          Upload Image
                          <input type="file" onChange={handleFileChange} />
                        </label>
                      </Tooltip>
                    </div>
                  </div>
                </Form.Item>

                <Form.Item
                  label="Website"
                  name="website"
                  rules={[
                    { required: true, message: "URL is required" },
                    {
                      type: "url",
                      message: "Please enter a valid URL",
                    },
                  ]}
                >
                  <Input
                    placeholder="https://example.com"
                    style={{ width: 300 }}
                  />
                </Form.Item>

                <Form.Item style={{ display: "flex", justifyContent: "end", textAlign: 'right', margin: '0' }}>
                  <Button className="sendBtn greenBtn" htmlType="submit" loading={isBtnDisabled}>
                    <span> Apply for approval</span>
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      {microSiteActions &&
        microSiteActions[previewId] &&
        microSiteActions[previewId]["preview"] &&
        microSiteActions[previewId]["preview"] ? (
        <Preview
          micrositeId={previewId}
          siteSetting={settings}
          closeSettings={() => {
            handleMenus(previewId, "preview", false);
            setPreviewId();
          }}
          data={previewRow}
        />
      ) : (
        <></>
      )}
      <div className="table-container">
        <Table
          rowClassName={() => "rowClassName1"}
          columns={columns}
          dataSource={totalData}
          pagination={{ pageSize: 10 }}
        />
      </div>
      <SecureDeleteFlow
        open={isModalDeleteOpen}
        onClose={handleCancelDelete}
        entityType="Site"
        entityId={deleteRowId}
        displayName={deleteSiteName}
        requiredRole={ROLE}
        warningMessage="Are you sure you want to delete this Site? This action is permanent and cannot be undone."
        successMessage="Site deleted successfully."
        validateBeforeSendOtp={validatePhoneBeforeDeleteOtp}
        sendOtp={() =>
          siteDeleteService.sendDeleteOtp({
            siteId: deleteRowId,
            siteName: deleteSiteName,
          })
        }
        verifyOtp={(otp) =>
          siteDeleteService.verifyDeleteOtp({
            siteId: deleteRowId,
            otp,
          })
        }
        deleteAction={(verificationResult) =>
          siteDeleteService.deleteSite({
            siteId: deleteRowId,
            verificationToken: verificationResult?.verificationToken,
          })
        }
        onSuccess={handleSecureDeleteSuccess}
      />

      <div className="footer">
        <div
          className="footer-content"
          onClick={() => window.open("https://www.connectsu.co.uk/", "_blank")}
          style={{ cursor: "pointer" }}
        >
          {/* <span>Powered by</span> */}
          <div className="footer-logo">
            <img
              src={require("../../assets/images/PoweredNew.png")}
              alt="company logo"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageMicrosite;
